import { NamedValueArray } from "@spotter/services/data/data-service";







/** Tracker naming constants for use with Matamo */
export const TrackerEvents = 
{
    // Reports
    c_Report: "Report",
        a_Report_Export: "Export",

    // Auth
    c_Auth: "Auth",
        a_Auth_Login: "Login",
        a_Auth_Register: "Register",
        a_Auth_Logout: "Logout",
        a_Auth_Reset: "Password Reset Complete",
        a_Auth_Forgot: "Password Reset Request",



};



export interface SightingStatistics
{
    total: number;
    mobile: number;
    missing_geo: number;
    unconfirmed: number;
    flagged: number;
    additional_data: number;
}

export interface AbsenceStatistics
{
    total: number;
    mobile: number;
    missing_geo: number;
    unconfirmed: number;
    flagged: number;
    additional_data: number;
    photos: number;
}








export interface AnalyticsStatistics
{
    visitors: number;
    visits: number;
    page_views: number;
    time_on_site: string;
    report_downloads: number;

    visits_by_group : {
        countries: NamedValueArray;
        languages: NamedValueArray;

        device_types: NamedValueArray;
        device_browsers: NamedValueArray;
        device_os: NamedValueArray;

        referrers: NamedValueArray;
        referrer_searches: NamedValueArray;
        referrer_websites: NamedValueArray;
        referrer_socials: NamedValueArray;

        pages: NamedValueArray;
        entry_pages: NamedValueArray;

        duration_per_visit: NamedValueArray;
        pages_per_visit: NamedValueArray;
    }

   
}
